export default "__VITE_ASSET__6a76ffc9__"